import * as moment from 'moment';
export const formatDate = (date) => {
	return moment.unix(date).format('DD/MM/YYYY hh:mm:ss A');
};
